import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

interface IBaseAdminToolsPermissionsState {
	canNavigateIDE: boolean;
	canNavigateWEB: boolean;
	canAccessConfigurationManager: boolean;
	canAccessFlowManager: boolean;
	canAccessSecurity: boolean;
	canAccessMenuDesigner: boolean;
	canViewLogs: boolean;
	canDocumentReport: boolean;
	canAccessProcessRequestManager: boolean;
	canTaskManagerView: boolean;
	canTaskManagerLogs: boolean;
	canTaskManagerStart: boolean;
	canTaskManagerStop: boolean;
	canViewLicense: boolean;
}

export interface IAdminToolsPermissionsState extends IBaseAdminToolsPermissionsState {}

export interface IReadonlyAdminToolsPermissionsState extends IBaseAdminToolsPermissionsState {}

export type AdminToolsPermissionsState = ReadonlyRecord<IReadonlyAdminToolsPermissionsState>;

export const AdminToolsPermissionsStateFactory = Record<IReadonlyAdminToolsPermissionsState>({
	canNavigateIDE: false,
	canNavigateWEB: false,
	canAccessConfigurationManager: false,
	canAccessFlowManager: true,
	canAccessSecurity: false,
	canAccessMenuDesigner: false,
	canViewLogs: false,
	canDocumentReport: false,
	canAccessProcessRequestManager: false,
	canTaskManagerView: false,
	canTaskManagerLogs: false,
	canTaskManagerStart: false,
	canTaskManagerStop: false,
	canViewLicense: false
});

export const AdminToolsPermissionsStateFactoryFromJS = function (
	data: IAdminToolsPermissionsState
) {
	return AdminToolsPermissionsStateFactory({
		...data
	});
};
